"use client";
import React from "react";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import TeacherCard from "../../shared/TeacherCard";
import MyLink from "@/components/shared/myLink/MyLink";

const AcademyInstructors = ({
  full = true,
  teachers,
  loading,
}: {
  full?: boolean;
  teachers: any;
  loading: boolean;
}) => {
  return (
    <div id="instructors" className="w-full max-w-7xl mx-auto">
      {full && (
        <div className="mb-10 text-center">
          <h2 className="text-3xl md:text-4xl font-extrabold mb-4 text-white">
            أفضل المدرسين المتخصصين
          </h2>
          <p className="text-lg md:text-xl text-[#C7D0E0] max-w-2xl mx-auto">
            المنصة تحتوي على نخبة من أفضل المدرسين المتخصصين في جميع المواد.
            يمكنك الاشتراك معهم وشراء الكورسات الخاصة بهم.
          </p>
        </div>
      )}
      {loading ? (
        <SkeletonTheme baseColor="#474A4D" highlightColor="#6b6e72">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {Array(4)
              .fill(0)
              .map((_, index) => (
                <div key={index} className="p-6 bg-[#323538] rounded-2xl">
                  <Skeleton height={220} className="rounded-xl mb-4" />
                  <Skeleton height={20} width="60%" className="mb-2" />
                  <Skeleton height={20} width="80%" />
                  <Skeleton height={40} width="90%" className="mt-3" />
                </div>
              ))}
          </div>
        </SkeletonTheme>
      ) : teachers && teachers.length > 0 ? (
        <Carousel opts={{ direction: "rtl", align: "center" }}>
          <CarouselContent className="pb-10">
            {teachers.map((teacher: any) => (
              <CarouselItem
                className="md:basis-1/2 xl:basis-1/3"
                key={teacher.id}
              >
                <TeacherCard
                  id={teacher?.id}
                  image={teacher?.image}
                  subject={teacher?.subject?.name}
                  teacherName={teacher?.name}
                  description={teacher?.description}
                  schoolYears={teacher?.school_years}
                  full={full}
                />
              </CarouselItem>
            ))}
          </CarouselContent>
          <div className="flex justify-center items-center gap-3 mt-4">
            <CarouselPrevious className="bg-primaryColor border-primaryColor hover:bg-primaryColor/80 text-white" />
            {full && (
              <MyLink
                href="/instructors"
                className="bg-[#323538] text-16 text-white font-[500] py-2 px-8 rounded-lg border border-primaryColor hover:bg-primaryColor hover:text-white transition"
              >
                عرض الكل
              </MyLink>
            )}
            <CarouselNext className="bg-primaryColor border-primaryColor hover:bg-primaryColor/80 text-white" />
          </div>
        </Carousel>
      ) : (
        full && (
          <div className="text-center text-red-400 bg-[#474A4D] rounded-lg py-6 px-4 mt-6">
            <p>لم يتم العثور على مدرسين.</p>
          </div>
        )
      )}
    </div>
  );
};

export default AcademyInstructors;
